<template>
  <div data-component-group="filter-forms" data-component="comment">
    <FiltersForm
      :has-filters="hasFilters"
      @filter="onFilter"
      @clear="onClearFilters"
      v-model="selectedCountries"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        label="Search"
        prepend-inner-icon="search"
      />

      <v-autocomplete
        clearable
        v-model="language"
        :items="languages"
        prepend-inner-icon="translate"
        item-title="name"
        item-value="code"
        label="Language"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import filterUrlSync from '@/mixins/filterUrlSync';
  import { isNonEmptyArr, escapeSearch } from '@/utils';

  // TODO: Translate component

  export default {
    mixins: [filterUrlSync],
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
          { field: 'language', urlKey: 'lang', type: 'string' },
          { field: 'selectedCountries', urlKey: 'countries', type: 'string[]' },
        ],
        search: null,
        language: null,
        selectedCountries: [],
      };
    },
    computed: {
      hasFilters() {
        const { search, selectedCountries, language } = this;

        return !!search || language !== null || isNonEmptyArr(selectedCountries)
      },
      countries() {
        return this.$store.getters['users/countries'];
      },
      languages() {
        return this.$store.getters['config/languages'];
      },
    },
    methods: {
      onFilter() {
        const { search, language } = this;
        const formattedSearch = escapeSearch(search);

        this.syncFiltersToUrl();


        this.$emit('filter', {
          search: formattedSearch,
          lang: language,
          countries: this.selectedCountries,
        });
      },
      onClearFilters() {
        this.search = null;
        this.selectedCountries = [];
        this.language = null;

        this.clearFiltersUrl();


        this.$emit('clearFilters');
      },
    },
  };
</script>
